import { render, staticRenderFns } from "./exam.vue?vue&type=template&id=960f8b16&scoped=true&"
import script from "./exam.vue?vue&type=script&lang=ts&"
export * from "./exam.vue?vue&type=script&lang=ts&"
import style0 from "./exam.vue?vue&type=style&index=0&id=960f8b16&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960f8b16",
  null
  
)

export default component.exports